import type { SettingsData } from '../../model/settings/interfaces'
import type { ApiResponse } from '@shared/api'

import { getAxiosErrorMessage } from '@shared/api'
import { useAdminRoutes } from '@shared/lib/routes'
import { useToast } from '@shared/ui/toast'

import { useSettingsStore } from '../../model/settings/store'

export const useSettingsApi = async (): Promise<SettingsData | null> => {
  const { $axios } = useNuxtApp()
  const toast = useToast()
  const store = useSettingsStore()

  const url = useAdminRoutes('admin.settings.data')

  store.setLoading(true)

  try {
    if (!url) {
      toast.error('Unexpected error. Invalid request URL.')
      return null
    }

    const { data } = await $axios.get<ApiResponse>(url)

    if (!data.success) {
      toast.error(data.message)
      return null
    }

    const settingsData: SettingsData | null = data.data || null

    if (settingsData) {
      store.setSettings(settingsData.settings)
      store.setExperiments(settingsData.experiments)
      store.setConfigVaultUrl(settingsData.config_vault_url)
    }

    return settingsData
  } catch (err: unknown) {
    toast.error(getAxiosErrorMessage(err))
    return null
  } finally {
    store.setLoading(false)
  }
}
